import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import ncogLogo from '../assets/images/companyLogo.png';
import Chrome from '../assets/images/chrome.png';
import Safari from '../assets/images/safari.png';
import Brave from '../assets/images/brave.png';
import Firefox from '../assets/images/firefox.png';
import Edge from '../assets/images/edge.png';
import "./modal.css";
import { getBrowserName } from '../helper/browserUtils';

const InstallWalletModal = ({ isOpen, onClose }) => {
    const [browserName, setBrowserName] = useState('');

    useEffect(() => {
        if (isOpen) {
            setBrowserName(getBrowserName());
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const browserIcons = {
        Chrome: { icon: Chrome, alt: 'Chrome' },
        Edge: { icon: Edge, alt: 'Edge' },
        Safari: { icon: Safari, alt: 'Safari' },
        Brave: { icon: Brave, alt: 'Brave' },
        Firefox: { icon: Firefox, alt: 'Firefox' },
    };
    const { icon: browserIcon, alt: browserAlt } = browserIcons[browserName] || { icon: Chrome, alt: browserName || 'Browser' };

    const browserBackgrounds = {
        Chrome: 'linear-gradient(90deg, rgb(251 223 189) 0%, rgb(254, 242, 242) 100%)',
        Edge: 'linear-gradient(90deg, rgb(202 231 255) 0%, rgb(230, 244, 255) 100%)',
        Safari: 'linear-gradient(90deg, #FDF6E3 0%, #F5F5DC 100%)',
        Brave: 'linear-gradient(90deg, #FFF3E0 0%, #FFE0B2 100%)',
        Firefox: 'linear-gradient(90deg, #FFF4E5 0%, #FFD7A9 100%)',
    };
    const browserCardBg = browserBackgrounds[browserName] || 'linear-gradient(90deg, #F8FAFC 0%, #F1F5F9 100%)';

    const handleChromeClick = () => {
        if(browserName === 'Firefox'){
            window.open('https://addons.mozilla.org/en-US/firefox/addon/ncog_wallet/', '_blank');
            onClose();
        } else {
            window.open('https://chromewebstore.google.com/detail/ncog-wallet/jbnhiemcghikpkifekbjkabplojnknmm?hl=en', '_blank');
            onClose();
        }
    };
    const handleWebAppClick = () => {
        window.open('https://wallet.ncog.earth/', '_blank');
        onClose();
    };
    return (
        <div className="modal-wallet-install">
            <div className="modal-content custom-modal-content">
                <div className="modal-header custom-modal-header">
                    <button onClick={onClose} className="modal-close-btn">
                        <X size={24} />
                    </button>
                </div>
                <div className="custom-modal-main">
                <div className="modal-body custom-modal-body">
                    <div className="custom-modal-flex-col">
                        <div className="custom-browser-card" style={{ background: browserCardBg }}>
                            <div className="custom-browser-flex">
                            <img src={browserIcon} alt={browserAlt} className="custom-browser-img" />
                            <div className="custom-browser-content">
                                <div className="custom-browser-title">NCOG Wallet for {browserName}</div>
                                <div className="custom-browser-desc">
                                    Access your wallet right from your favorite web browser.
                                </div>
                            <button
                                className="custom-browser-btn"
                                onClick={handleChromeClick}
                            >
                                Add to {browserName}
                            </button>
                            </div>
                            </div>
                        </div>
                       
                        </div>
                    </div>
                    <div className="modal-body custom-modal-body">
                    <div className="custom-modal-flex-col">
                        <div className="custom-webapp-card">
                            <div className="custom-browser-flex">
                            <img src={ncogLogo} alt="NCOG Wallet" className="custom-browser-img" />
                            <div className="custom-browser-content">
                                <div className="custom-browser-title">NCOG Wallet</div>
                                <div className="custom-browser-desc">
                                    World's First Post-Quantum Secure Data Wallet 
                                </div>
                            <button
                                className="custom-browser-btn"
                                onClick={handleWebAppClick}
                            >
                                Open NCOG Wallet website </button>
                            </div>
                            </div>
                        </div>
                        </div>
                        </div>
                    </div>
             </div>
        </div>
    );
};

export default InstallWalletModal; 